import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class FormattedPlural extends Component {
  render () {
    const { value, one, other } = this.props
    return (
      <span>{value !== 1 ? other : one}</span>
    )
  }
}

FormattedPlural.propTypes = {
  value: PropTypes.number,
  one: PropTypes.string,
  other: PropTypes.string
}
